<template>
    <div class="products-list">
        <div class="products-list--heading">
            <div>
                <div class="products-list--title">
                    Da prenotare con un click
                </div>
                <div class="products-list--subtitle">
                    Soluzioni di viaggio complete e pronte da prenotare col tuo credito welfare
                </div>
            </div>
            <div class="products-list--cta">
                <button-with-icon
                    v-if="show_cta"
                    variant="cta"
                    text="Vedi tutto"
                    :icon="chevron_right"
                    :clicked="() => {
                        router.push({ name: 'category', params: { category_code: category_code } })
                    }"
                />
            </div>
        </div>
        <div class="products-list--content">
            <slick :class="'mode-'+mode" ref="slick-category" :options="slick_options" @init="slick_init">
                <div v-for="result in results" v-bind:key="result.travelId">
                    <div class="item" @click="router.push({ name: 'detail', params: { travel_id: result.productCode } })">
                        <div class="item--cover" :style="'background-image:url('+(result.coverUrl ? result.coverUrl : categories[result.categoryCode].padImage)+')'"></div>
                        <div class="item--title" v-html="result.title"></div>
                        <div class="item--price">
                            € {{ result.public_price }}
                        </div>
                    </div>
                </div>
            </slick>
            <div :prev="_uid" v-html="chevron_left"></div>
            <div :next="_uid" v-html="chevron_right"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Slick from 'vue-slick'
    import Router from '@/router'
    import Bwi from '@/components/atoms/button-with-icon'
    import { chevron_left, chevron_right } from '@/components/svg/chevrons'
    export default {
        name: 'products-list',
        components: {
            'slick': Slick,
            'button-with-icon': Bwi,
        },
        props: {
            category_code: String,
            results: Array,
            mode: {
                type: String,
                default: 'slider',//list
            },
            show_cta: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                categories: Vue.prototype.$config.livetravelCategories,
                slick_options:
                {
                    slidesToShow: 4,
                    //slidesToScroll: 4,
                    //arrows: false,
                    prevArrow: '[prev='+this._uid+']',
                    nextArrow: '[next='+this._uid+']',
                    draggable: false,
                    responsive:[
                        {
                            breakpoint: 1140,
                            settings: {
                                slidesToShow: 3,
                                //slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 1023,
                            settings: {
                                slidesToShow: 2,
                                //slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                //slidesToScroll: 1,
                            }
                        },                        
                    ],
                }
            }
        },
        computed: {
        },
        created()
        {
            this.router = Router
            this.chevron_left = chevron_left
            this.chevron_right = chevron_right
        },
        mounted() {            
        },
        methods:{
            slick_init(event, slick) {
                (event, slick)
                if(this.mode !== 'slider')
                {
                    slick.unslick()
                }
            },
        },
    }
</script>

<style lang="scss">
.products-list
{

    .mode-list
    {
        display:flex;
        flex-wrap: wrap;
        &>div
        {
            width:100%;
            @include media-breakpoint-up(md)
            {
                width:50%;
            }
            @include media-breakpoint-up(lg)
            {
                width:25%;
            }
        }
    }
}
</style>